import trLocale from 'element-ui/lib/locale/lang/tr-TR' //引入element语言包
const tr = {
  Login: {
    ToLogin: 'giriş',
    PhoneLogin: 'Telefon numarası ile gir',
    EmailLogin: 'E-posta giriş',
    PhonePlaceholder: 'Lütfen telefon numarasını girin.',
    EmailPlaceholder: 'Enter email',
    Code: 'Kontrol kodu',
    and: 've',
    BeforeText: 'Bir hesap oluşturmak anlaşmanızı ve uyumluluğunuzu temsil ediyor.',
    UserAgreement: 'Kullanıcı Anlaşması',
    privacy: 'Gizlilik politikası',
    errorMessage: 'Kontrol kodu hatası',
    readTitle: 'Bu anlaşmayı okuyun ve kabul edin.',
    readBefore: 'Kişisel bilgilerinizin güvenliğini sağlamak için, lütfen önce okuyun ve kabul edin.',
    cancel: 'iptal et',
    agree: 'Anlaşıldı ve devam et',
    error1:'Lütfen geçerli bir e-posta adresini girin.',
    error2:'Lütfen doğru telefon numarasını girin.',
    error3:'Kodu girin lütfen',
    success:'Başarılı Giriş'
  },
  ...trLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default tr;
